<template>
  <div class="column">
    <slot></slot>

    <fieldset v-if="filteredAvailableSettings.has('yAxisLabelsVisible')" class="menu-fieldset">
      <legend class="label">{{ $t("labels.yAxis") }}</legend>
      <div class="column">
        <input-checkbox
          v-if="filteredAvailableSettings.has('yAxisTitleVisible')"
          :value="settings.yAxisTitleVisible || false"
          :label="$t('labels.showAxisTitle')"
          name="yAxisTitleVisible"
          @update:value="updateSetting('yAxisTitleVisible', $event)"
        />
        <input-checkbox
          v-if="filteredAvailableSettings.has('yAxisLabelsVisible')"
          :value="settings.yAxisLabelsVisible || false"
          :label="$t('labels.showTickLabels')"
          name="yAxisLabelsVisible"
          @update:value="updateSetting('yAxisLabelsVisible', $event)"
        />
        <input-checkbox
          v-if="
            filteredAvailableSettings.has('centered') &&
            ctx.preSettings.centered !== false
          "
          :value="settings.centered || false"
          :label="$t('labels.centered')"
          name="centered"
          @update:value="updateSetting('centered', $event)"
        />
        <input-checkbox
          v-if="
            filteredAvailableSettings.has('scaleColorsVisible') &&
            ctx.preSettings.scaleColorsVisible !== false
          "
          :value="settings.scaleColorsVisible || false"
          :label="$t('labels.showDiagramColors')"
          name="scaleColorsVisible"
          @update:value="updateSetting('scaleColorsVisible', $event)"
        />
        <input-checkbox
          v-if="
            filteredAvailableSettings.has('zoomed') && ctx.preSettings.zoomed !== false
          "
          :value="settings.zoomed || false"
          :label="$t('labels.zoomDiagram')"
          name="zoomed"
          @update:value="updateSetting('zoomed', $event)"
        />
      </div>
    </fieldset>

    <fieldset v-if="filteredAvailableSettings.has('xAxisLabelsVisible')" class="menu-fieldset">
      <legend class="label">{{ $t("labels.xAxis") }}</legend>
      <div class="column">
        <input-checkbox
          v-if="filteredAvailableSettings.has('xAxisTitleVisible')"
          :value="settings.xAxisTitleVisible || false"
          :label="$t('labels.showAxisTitle')"
          name="xAxisTitleVisible"
          @update:value="updateSetting('xAxisTitleVisible', $event)"
        />
        <input-checkbox
          v-if="filteredAvailableSettings.has('xAxisLabelsVisible')"
          :value="settings.xAxisLabelsVisible || false"
          :label="$t('labels.showTickLabels')"
          name="xAxisLabelsVisible"
          @update:value="updateSetting('xAxisLabelsVisible', $event)"
        />
        <input-checkbox
          v-if="filteredAvailableSettings.has('xAxisLabelsShortened') && settings.xAxisLabelsVisible"
          :value="settings.xAxisLabelsShortened || false"
          :label="$t('labels.titlesShortened')"
          name="xAxisLabelsShortened"
          @update:value="updateSetting('xAxisLabelsShortened', $event)"
        />

        <input-checkbox
          v-if="
            filteredAvailableSettings.has('roundEffectsVisible') &&
            ctx.preSettings.roundEffectsVisible !== false
          "
          :value="settings.roundEffectsVisible || false"
          :label="$t('labels.roundEffectsVisible')"
          name="roundEffectsVisible"
          @update:value="updateSetting('roundEffectsVisible', $event)"
        />
      </div>
    </fieldset>

    <fieldset class="menu-fieldset">
      <legend class="label">{{ $t("labels.chartGroups") }}</legend>
      <div class="column">
        <input-checkbox
          v-if="filteredAvailableSettings.has('groupLabelsVisible')"
          :value="settings.groupLabelsVisible || false"
          :label="$t('labels.groupLabelsVisible')"
          name="groupLabelsVisible"
          @update:value="updateSetting('groupLabelsVisible', $event)"
        />
        <input-checkbox
          v-if="filteredAvailableSettings.has('groupLabelsShortened') && settings.groupLabelsVisible"
          :value="settings.groupLabelsShortened || false"
          :label="$t('labels.titlesShortened')"
          name="groupLabelsShortened"
          @update:value="updateSetting('groupLabelsShortened', $event)"
        />
        <input-checkbox
          v-if="
            filteredAvailableSettings.has('endPointsVisible') &&
            ctx.preSettings.endPointsVisible !== false
          "
          :value="settings.endPointsVisible || false"
          :label="$t('labels.endPointsVisible')"
          name="endPointsVisible"
          @update:value="updateSetting('endPointsVisible', $event)"
        />
        <input-checkbox
          v-if="
            filteredAvailableSettings.has('areasColored') &&
            ctx.preSettings.areasColored !== false
          "
          :value="settings.areasColored || false"
          :label="$t('labels.areasColored')"
          name="areasColored"
          @update:value="updateSetting('areasColored', $event)"
        />

        <input-checkbox
          v-if="
            filteredAvailableSettings.has('areasFilled') &&
            ctx.preSettings.areasFilled !== false
          "
          :value="settings.areasFilled || false"
          :label="$t('labels.areasFilled')"
          name="areasFilled"
          @update:value="updateSetting('areasFilled', $event)"
        />
      </div>
    </fieldset>

    <fieldset class="menu-fieldset">
      <legend class="label">{{ $t("labels.design") }}</legend>
      <div class="column">
        <input-checkbox
          v-if="filteredAvailableSettings.has('titleVisible')"
          :value="settings.titleVisible || false"
          :label="$t('labels.titleVisible')"
          name="titleVisible"
          @update:value="updateSetting('titleVisible', $event)"
        />

        <input-checkbox
          v-if="filteredAvailableSettings.has('ticksVisible')"
          :value="settings.ticksVisible || false"
          :label="$t('labels.showDiagramGuidelines')"
          name="ticksVisible"
          @update:value="updateSetting('ticksVisible', $event)"
        />

        <input-checkbox
          v-if="filteredAvailableSettings.has('filterZeroValues')"
          :value="settings.filterZeroValues || false"
          :label="$t('labels.filterZeroValues')"
          name="filterZeroValues"
          @update:value="updateSetting('filterZeroValues', $event)"
        />

        <input-checkbox
          v-if="
            filteredAvailableSettings.has('subValuesVisible') &&
            ctx.preSettings.subValuesVisible !== false
          "
          :value="settings.subValuesVisible || false"
          :label="$t('labels.subValuesVisible')"
          name="subValuesVisible"
          @update:value="updateSetting('subValuesVisible', $event)"
        />

        <div v-if="filteredAvailableSettings.has('width')">
          <div v-if="fixedSize" class="line">
            <input-number
              :label="$t('labels.width')"
              :value="settings.width || 0"
              :max="10000"
              :min="300"
              name="width"
              @update:value="updateSetting('width', $event)"
            />
            <span class="label self-end pb-2">px</span>
          </div>
          <template v-else>
            <input-checkbox
              :value="widthIsDynamic && settings.width == null"
              :label="$t('labels.autoWidth')"
              name="autoWidth"
              @update:value="
                {
                  widthIsDynamic = $event;
                  if ($event) {
                    updateSetting('width', null);
                  }
                }
              "
            />
            <template v-if="settings.width != null || !widthIsDynamic">
              <label class="label">{{ $t("labels.width") }}</label>
              <input-range
                :value="settings.width ?? bodyWidth"
                :min="300"
                :max="2500"
                name="width"
                @update:value="updateSetting('width', $event)"
              >
                <template
                  #after="{
                    value: cachedValue,
                    maxValue,
                    minValue,
                    disabled,
                    onChange,
                    onUpdate
                  }"
                >
                  <input-number
                    class="input_small"
                    :disabled="disabled"
                    :value="cachedValue"
                    :max="maxValue"
                    :min="minValue"
                    name="width"
                    @change="onChange"
                    @update:value="onUpdate"
                  />
                </template>
              </input-range>
            </template>
          </template>
        </div>

        <div v-if="filteredAvailableSettings.has('height')">
          <div v-if="fixedSize" class="line">
            <input-number
              :label="$t('labels.height')"
              :value="settings.height ?? 0"
              :max="10000"
              :min="300"
              name="height"
              @update:value="updateSetting('height', $event)"
            />
            <span class="label self-end pb-2">px</span>
          </div>
          <template v-else>
            <input-checkbox
              :value="settings.height == null && heightIsDynamic"
              :label="$t('labels.autoHeight')"
              name="autoHeight"
              @update:value="
                {
                  heightIsDynamic = $event;
                  if ($event) {
                    updateSetting('height', null);
                  }
                }
              "
            />
            <template v-if="settings.height != null || !heightIsDynamic">
              <label class="label">{{ $t("labels.height") }}</label>
              <input-range
                :value="settings.height ?? bodyHeight"
                :min="200"
                :max="2000"
                name="height"
                @update:value="updateSetting('height', $event)"
              >
                <template
                  #after="{
                    value: cachedValue,
                    maxValue,
                    minValue,
                    disabled,
                    onChange,
                    onUpdate
                  }"
                >
                  <input-number
                    class="input_small"
                    :disabled="disabled"
                    :value="cachedValue"
                    :max="maxValue"
                    :min="minValue"
                    name="height"
                    @change="onChange"
                    @update:value="onUpdate"
                  />
                </template>
              </input-range>
            </template>
          </template>
        </div>

        <input-number
          v-if="filteredAvailableSettings.has('fontSize')"
          :value="settings.fontSize"
          :label="$t('labels.fontSize')"
          :min="6"
          name="fontSize"
          @update:value="updateSetting('fontSize', $event)"
        />
      </div>
    </fieldset>

    <slot name="after"></slot>
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from "vue";
import { useReactiveChartData } from "./useChartData";

import InputRange from "@core/input/InputRange.vue";
import InputNumber from "@core/input/InputNumber.vue";
import InputCheckbox from "@core/input/InputCheckbox.vue";

import type { ChartItemOptions } from "@editor/items/charts/useChartData";

import type { ChartSettings } from "@editor/items/charts/ChartItem";

interface Props {
  chart: ChartItemOptions;
  settings: Partial<ChartSettings>;
  bodyHeight?: number;
  bodyWidth?: number;
  fixedSize?: boolean;
  removeSettings?: (keyof ChartSettings)[];
}
const props = withDefaults(defineProps<Props>(), {
  bodyHeight: 500,
  bodyWidth: 1000,
  fixedSize: false,
  removeSettings: () => []
});

const emit = defineEmits<{
  (e: "update", data: Partial<ChartSettings>): void;
}>();

const ctx = useReactiveChartData(
  () => props.chart
);

let widthIsDynamic = ref(props.settings.width == null);
let heightIsDynamic = ref(props.settings.height == null);

const filteredAvailableSettings = computed(() => {
  const settings = new Set(ctx.availableSettings);
  for (const key of props.removeSettings) {
    settings.delete(key);
  }
  return settings;
});

function updateSetting<K extends keyof ChartSettings>(
  key: K,
  value: ChartSettings[K]
) {
  emit("update", { [key]: value });
}
</script>

<style lang="scss"></style>
